import { styled } from '@mui/material/styles';

const StyledUserDataPromptItem = styled('div')`
  margin-bottom: 20px;
  width: 100%;

  & > label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6b7280;
    margin-bottom: 8px;
  }

  & > input {
    width: 100%;
    padding: 12px 20px;
    box-sizing: border-box;
    font-size: 15px;
    color: #374151;
    background-color: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 24px;
    outline: none;
    transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease;
  }
  & > input[placeholder] {
    color: #9ca3af;
  }
  & > input:focus {
    border-color: #4a9eff;
    box-shadow: 0 0 0 3px rgba(74, 158, 255, 0.1);
  }
`;

export default StyledUserDataPromptItem;
